import { z } from "zod"

const url = "/harvest"

const harvestMetric = (value: HarvesterResults) => {
  const body = JSON.stringify(value)

  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, body)
  } else {
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body,
    }).catch(err => {
      console.error("Failed to send harvest metric", err)
    })
  }
}

// ExperimentEvent

export const HarvestedExperimentEventSchema = z.object({
  type: z.literal("experiment_event"),
  experiment_id: z.string(),
  variation_id: z.string(),
  action: z.string(),
  // Present on order-placed only. Advisory: it exists so conversion counts can be reconciled against the orders
  // table, and is never used to look anything up or authorize anything.
  order_id: z.number().optional(),
})

export type HarvestedExperimentEvent = z.infer<typeof HarvestedExperimentEventSchema>

export const harvestExperimentEvent = (
  experiment_id: string,
  variation_id: string,
  action: string,
  order_id?: number
) => {
  harvestMetric({ type: "experiment_event", experiment_id, variation_id, action, order_id })
}

// ExperimentAssignment

export const HarvestedExperimentAssignmentSchema = z.object({
  type: z.literal("experiment_assignment"),
  experiment_id: z.string(),
  variation_id: z.string(),
})

export type HarvestedExperimentAssignment = z.infer<typeof HarvestedExperimentAssignmentSchema>

export const harvestExperimentAssignment = (experiment_id: string, variation_id: string) => {
  harvestMetric({ type: "experiment_assignment", experiment_id, variation_id })
}

export const HarvesterSchemas = z.discriminatedUnion("type", [
  HarvestedExperimentEventSchema,
  HarvestedExperimentAssignmentSchema,
])
export type HarvesterResults = z.infer<typeof HarvesterSchemas>
